import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';

@Pipe({
  name: 'translateDirectus',
})
export class TranslateDirectusPipe implements PipeTransform {
  private readonly translocoService = inject(TranslocoService);

  transform(
    translations: any[] | null | undefined,
    key = 'name',
    acceptUndefined = false,
    language?: string,
  ): string | undefined {
    const activeLanguage = language ?? this.translocoService.getActiveLang();

    if (!translations || translations.length === 0) {
      // while loading is null or undefined
      return 'No translations data';
    }

    const translation: any = translations.find((t: any) => t.language === activeLanguage);

    if (translation && translation[key]) {
      return String(translation[key]);
    }

    const fallbackTranslation: any = translations.find((t: any) => t[key]);

    if (fallbackTranslation) {
      return String(fallbackTranslation[key]);
    }

    if (acceptUndefined) {
      return undefined;
    }
    return `Error: Missing key: ${key} for lang ${activeLanguage} in ${translations[0]?.relationship_id}`;
  }
}
